export default __webpack_public_path__ + "static/media/Kenzie-Compressed.e37725e1.png";